<template>
  <div class="myRankView">
    <!-- ヘッダ -->
    <div class="myRankView__header">
      {{ $t('rankingHeaderUser', { userName: result.streamerUser.nickname }) }}
    </div>
    <!-- 自分の順位表示 -->
    <ranking-cell :result="result"></ranking-cell>
  </div>
</template>

<script>
import RankingCell from './RankingCell.vue'

export default {
  components: {
    RankingCell,
  },
  name: 'MyRankingView',
  props: {
    result: {
      rank: Number,
      score: Number,
      streamerUser: {
        nickname: String,
        iconUrl: String,
        vliveId: String,
        profileId: String,
      },
    },
  },
}
</script>

<style scoped>
.myRankView {
  display: block;
  margin-top: 16px;
}
.myRankView__header {
  width: 100%;
  max-width: 500px;
  height: 40px;
  font-family: Hiragino Kaku Gothic ProN;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 40px;
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
